export default __webpack_public_path__ + "static/media/Seven Section.6896c19b.png";